export default __webpack_public_path__ + "static/media/section4-virtualassistance.804bc1f6.jpeg";